import FieldSet from '../../FieldSet';

import { StartDate } from './StartDate';
import { StartOn } from './StartOn';
import { DueDate } from './DueDate';
import { EndDate } from './EndDate';
import { EndOn } from './EndOn';

export class SchedulingFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [StartDate, StartOn, DueDate, EndDate, EndOn];
  }

  get title() {
    if (this.modelClass.typename === 'Task') {
      return 'Due date';
    }

    return 'Date range';
  }
}
